
const MarginBottomContainer = ({children, margin}) => {
    return (
        <div style={{marginBottom: `${margin}px`, display: "flex", flexDirection: "row", alignItems: "center", position: "relative"}}>
            {children}
        </div>
    )
}

export default MarginBottomContainer;
